export class EmptyState {
  constructor(props) {
    this.parentElement = props.element;
    this.settings = {
      message: 'No data to display.',
      ...props.settings
    };
    this.border = props.border || false;
    this.height = props.height;
  }

  init() {
    this.render();
    this.addEventListeners();
  }

  destroy() {
    this.removeEventListeners();
  }

  render() {
    if (this.parentElement.querySelector('.empty-state')) {
      this.removeEventListeners();
      this.parentElement.querySelector('.empty-state').remove();
    }

    const container = document.createElement('div');
    container.classList.add('empty-state');
    if (this.border) {
      container.classList.add('border');
    }

    const message = document.createElement('div');
    message.classList.add('message');
    container.append(message);

    const messageText = document.createElement('p');
    messageText.innerHTML = this.settings.message.trim();
    message.append(messageText);

    if (this.settings.button) {
      const button = document.createElement('button');
      button.classList.add('btn');
      button.innerHTML = this.settings.button.trim();
      message.append(button);
    }

    if (this.height) {
      container.style.height = `${this.height}px`;
    }

    this.parentElement.append(container);
  }

  addEventListeners() {
    if (this.settings.action) {
      this.parentElement.querySelector('.btn').addEventListener('click', this.settings.action);
    }
  }

  removeEventListeners() {
    if (this.settings.action) {
      this.parentElement.querySelector('.btn').removeEventListener('click', this.settings.action);
    }
  }
}
